var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceshiptwoRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21.875px",
    height: "21.875px",
    viewBox: "0 0 21.875 21.875",
    enableBackground: "new 0 0 21.875 21.875",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 0.938,
    fill: "#420863",
    width: 4,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8.958,
    fill: "#420863",
    width: 20,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 0.937,
    transform: "matrix(0.7072 0.707 -0.707 0.7072 10.9543 -4.5743)",
    fill: "#420863",
    width: 4,
    height: 20
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.984,
    y: 8.953,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 10.9622 -4.5593)",
    fill: "#420863",
    width: 20.001,
    height: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceshiptwoRight);
export default __webpack_public_path__ + "static/media/spaceshiptwo-right.3fba11e9b62001ead58f4491065a5efe.svg";
export { ForwardRef as ReactComponent };